import React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import InfoCard from './InfoCard';
import styles from '../TripTrackingV2.module.scss';

const formatGate = (label, value) => `${label}: ${value ? moment(value).format('DD MMM, HH:mm') : '-'}`;

const RouteTimeline = ({ routeMap = [] }) => {
  if (!routeMap.length) return null;

  return (
    <InfoCard title="Route">
      <div className={styles.timeline}>
        {routeMap.map((stop, index) => (
          <div
            className={classNames(styles.timelineItem, { [styles.timelineItemReached]: stop.reached })}
            key={stop.branch_id || index}
          >
            <div className={styles.timelineCity}>
              {stop.display_name || stop.displayName || `${stop.city}, ${stop.state}`}
            </div>
            <div className={styles.timelineMeta}>{formatGate('Gate In', stop.is_in)}</div>
            <div className={styles.timelineMeta}>{formatGate('Gate Out', stop.is_out)}</div>
          </div>
        ))}
      </div>
    </InfoCard>
  );
};

export default RouteTimeline;
